/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const childRoutes = [];

// Permit Venue Details
childRoutes[childRoutes.length] = {
    path: '/vehiclepermits/:permitId',
    exact: true,
    componentName: 'VenuePage',
    title: 'Permit Venue Details',
};

// Order Details
childRoutes[childRoutes.length] = {
    path: '/vehiclepermits/:permitId/registration/:reservationId?',
    exact: true,
    componentName: 'PermitRegistrationPage',
    title: 'Order Details',
    requireAuth: true,
};

// Order Details
childRoutes[childRoutes.length] = {
    path: '/vehiclepermits/:permitId/order/detail/:reservationId?',
    componentName: 'PermitRegistrationDetailPage',
    title: 'Order Details',
    requireAuth: true,
};

// Order Confirmation
childRoutes[childRoutes.length] = {
    path: '/vehiclepermits/:permitId/confirmation',
    componentName: 'CartlessConfirmationPage',
    title: 'Order Confirmation',
};

// Availability Page
childRoutes[childRoutes.length] = {
    path: '/vehiclepermits/:permitId/availability',
    componentName: 'DetailedAvailabilityPage',
    title: 'Detailed Availability',
};

// Additional Permit Holder Page
childRoutes[childRoutes.length] = {
    path: '/vehiclepermits/:permitId/registration/:reservationId/additional',
    componentName: 'AlternatePermitHolderConfirmationPage',
    title: 'Additional Permit Holder',
    requireAuth: true,
};

export default childRoutes;
